// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xg4GP","col":"styles_col__1pDaO"};